import { useQuery } from '@tanstack/react-query';
import queryKeys from '../keys/queryKeys';
import useMutateHook from '../../useMutateHook';
import { postLogin } from '../service/auth';
import { getPosts, getPostsComments, getPostsYearMonth, postPosts } from '../service/posts';
import { getSiteDetail, getSites, postSites, putSiteMemo } from '../service/sites';

//현장 조회
export function useSites({ memberId }) {
  return useQuery({
    queryKey: [...queryKeys.sitesKeys.list, memberId],
    queryFn: () => getSites({ memberId }),
    enabled: !!memberId,
  });
}

//현장 등록
export function useSiteAdd({ memberId }) {
  return useMutateHook({
    fetchApi: ({ siteName, siteAddress, siteAlias, geometry, memo }) => postSites({ memberId, siteName, siteAddress, siteAlias, geometry, memo }),
    invalidQuery: [queryKeys.sitesKeys.list],
  });
}

//현장 상세
export function useSiteDetail({ siteId }) {
  return useQuery({
    queryKey: [queryKeys.sitesKeys.detail(siteId)],
    queryFn: () => getSiteDetail({ siteId }),
    enabled: !!siteId,
  });
}

//현장 메모 수정
export function useSiteMemoEdit({ siteId }) {
  return useMutateHook({
    fetchApi: ({ memo }) => putSiteMemo({ siteId, memo }),
    invalidQuery: [[queryKeys.sitesKeys.detail(siteId)]],
  });
}
